import { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';

const useCheckAvailability = ({ product, itemIds = [] }) => {
  const { storeId } = useStore() || {};
  const { deliveryZip } = useContext(ExperienceContext) || {};
  const { getAvailability } = product?.features || {};

  const skip = !getAvailability || !deliveryZip || !storeId || !itemIds?.length;

  const { data, loading, error } = useDataModel('checkAvailability', {
    variables: {
      itemIds,
      zipCode: deliveryZip,
      localStoreId: storeId
    },
    skip
  });

  return {
    data,
    loading,
    error
  } || {};
};

export { useCheckAvailability };